import { BookingQuestionFieldType } from "../GeneratedGraphQL";
import { ExternalBookingQuestion } from "../AppDataProvider/types";

/**
 * Text questions
 */
export const optionalTextBookingQuestionId = "optional_text_booking_question";
export const optionalTextBookingQuestion: ExternalBookingQuestion = {
  id: optionalTextBookingQuestionId,
  name: "Optional text booking question",
  required: false,
  type: BookingQuestionFieldType.Text,
};
export const requiredTextBookingQuestion: ExternalBookingQuestion = {
  id: "required_text_booking_question",
  name: "Required text booking question",
  required: true,
  type: BookingQuestionFieldType.Text,
};

/**
 * File upload questions
 */
export const optionalFileUploadBookingQuestionId =
  "optional_file_upload_booking_question";
export const optionalFileUploadBookingQuestion: ExternalBookingQuestion = {
  id: "optional_file_upload_booking_question",
  name: "Optional file upload booking question",
  required: false,
  type: BookingQuestionFieldType.File,
};
export const requiredFileUploadBookingQuestion: ExternalBookingQuestion = {
  id: "required_file_upload_booking_question",
  name: "Required file upload booking question",
  required: true,
  type: BookingQuestionFieldType.File,
};

/**
 * Terms and conditions questions
 */
export const optionalTermsAndConditionsBookingQuestion: ExternalBookingQuestion =
  {
    id: "optional_terms_and_conditions_booking_question",
    name: "Optional terms and conditions booking question",
    required: false,
    type: BookingQuestionFieldType.Terms,
    url: "https://isitchristmas.com/",
  };
export const requiredTermsAndConditionsBookingQuestion: ExternalBookingQuestion =
  {
    id: "required_terms_and_conditions_booking_question",
    name: "Required terms and conditions booking question",
    required: true,
    type: BookingQuestionFieldType.Terms,
    url: "https://isitchristmas.com/",
  };
export const termsAndConditionsBookingQuestionWithDefaultLabel: ExternalBookingQuestion =
  {
    id: "terms_and_conditions_booking_question_with_default_label",
    name: "",
    required: false,
    type: BookingQuestionFieldType.Terms,
    url: "https://isitchristmas.com/",
  };

/**
 * Checkbox questions
 */
export const optionalCheckboxBookingQuestion: ExternalBookingQuestion = {
  id: "optional_checkbox_booking_question",
  name: "Optional checkbox booking question",
  required: false,
  type: BookingQuestionFieldType.Checkbox,
};
export const requiredCheckboxBookingQuestion: ExternalBookingQuestion = {
  id: "required_checkbox_booking_question",
  name: "Required checkbox booking question",
  required: true,
  type: BookingQuestionFieldType.Checkbox,
};
export const checkboxBookingQuestionWithSubquestions: ExternalBookingQuestion =
  {
    id: "checkbox_booking_question_with_subquestions",
    name: "Checkbox booking question with subquestions",
    required: false,
    subquestions: [
      {
        id: "text_subquestion",
        name: "Text subquestion",
        required: false,
        type: BookingQuestionFieldType.Text,
      },
      {
        id: "required_subquestion",
        name: "Required subquestion",
        required: true,
        type: BookingQuestionFieldType.Text,
      },
      {
        id: "file_upload_subquestion",
        name: "File upload subquestion",
        required: false,
        type: BookingQuestionFieldType.File,
      },
      {
        id: "terms_and_conditions_upload_subquestion",
        name: "Terms and conditions subquestion",
        required: false,
        type: BookingQuestionFieldType.Terms,
        url: "https://isitchristmas.com/",
      },
      {
        id: "terms_and_conditions_upload_subquestion_no_label",
        name: "",
        required: false,
        type: BookingQuestionFieldType.Terms,
        url: "https://isitchristmas.com/",
      },
      {
        id: "checkbox_subquestion",
        name: "Checkbox subquestion",
        required: false,
        type: BookingQuestionFieldType.Checkbox,
      },
      {
        id: "dropdown_subquestion",
        name: "Dropdown subquestion",
        options: [
          { optionId: "abc", value: "Option A" },
          { optionId: "def", value: "Option B" },
          { optionId: "ghi", value: "Option C" },
        ],
        required: false,
        type: BookingQuestionFieldType.Dropdown,
      },
    ],
    type: BookingQuestionFieldType.Checkbox,
  };

/**
 * Dropdown questions
 */
export const optionalDropdownBookingQuestion: ExternalBookingQuestion = {
  id: "optional_dropdown_booking_question",
  name: "Optional dropdown booking question",
  options: [
    { optionId: "123", value: "Option 1" },
    { optionId: "456", value: "Option 2" },
    { optionId: "789", value: "Option 3" },
  ],
  required: false,
  type: BookingQuestionFieldType.Dropdown,
};
export const requiredDropdownBookingQuestion: ExternalBookingQuestion = {
  id: "required_dropdown_booking_question",
  name: "Required dropdown booking question",
  options: [
    { optionId: "123", value: "Option 1" },
    { optionId: "456", value: "Option 2" },
    { optionId: "789", value: "Option 3" },
  ],
  required: true,
  type: BookingQuestionFieldType.Dropdown,
};
export const legacyDropdownBookingQuestion: ExternalBookingQuestion = {
  id: "legacy_dropdown_booking_question",
  name: "Legacy dropdown booking question",
  options: [
    { value: "Option 1" },
    { value: "Option 2" },
    { value: "Option 3" },
  ],
  required: false,
  type: BookingQuestionFieldType.Dropdown,
};
export const dropdownBookingQuestionWithSubquestions: ExternalBookingQuestion =
  {
    id: "dropdown_booking_question_with_subquestions",
    name: "Dropdown booking question with subquestions",
    options: [
      { optionId: "123", value: "Show subquestions" },
      { optionId: "456", value: "Do not show subquestions" },
    ],
    required: false,
    subquestions: [
      {
        dropdownTriggers: ["123"],
        id: "text_subquestion",
        name: "Text subquestion",
        required: false,
        type: BookingQuestionFieldType.Text,
      },
      {
        id: "required_subquestion",
        name: "Required subquestion",
        required: true,
        type: BookingQuestionFieldType.Text,
      },
      {
        dropdownTriggers: ["123"],
        id: "file_upload_subquestion",
        name: "File upload subquestion",
        required: false,
        type: BookingQuestionFieldType.File,
      },
      {
        dropdownTriggers: ["123"],
        id: "terms_and_conditions_upload_subquestion",
        name: "Terms and conditions subquestion",
        required: false,
        type: BookingQuestionFieldType.Terms,
        url: "https://isitchristmas.com/",
      },
      {
        dropdownTriggers: ["123"],
        id: "checkbox_subquestion",
        name: "Checkbox subquestion",
        required: false,
        type: BookingQuestionFieldType.Checkbox,
      },
      {
        dropdownTriggers: ["123"],
        id: "dropdown_subquestion",
        name: "Dropdown subquestion",
        options: [
          { optionId: "abc", value: "Option A" },
          { optionId: "def", value: "Option B" },
          { optionId: "ghi", value: "Option C" },
        ],
        required: false,
        type: BookingQuestionFieldType.Dropdown,
      },
    ],
    type: BookingQuestionFieldType.Dropdown,
  };

/**
 * Miscellaneous
 */
export const serviceLimitedBookingQuestion: ExternalBookingQuestion = {
  id: "service_limited_booking_question",
  name: "Service-limited booking question",
  required: false,
  services: [{ _id: "000000000000000000000001" }],
  type: BookingQuestionFieldType.Text,
};

export const bookingQuestions = [
  // Text questions
  optionalTextBookingQuestion,
  requiredTextBookingQuestion,
  // File upload questions
  optionalFileUploadBookingQuestion,
  requiredFileUploadBookingQuestion,
  // T&C questions
  optionalTermsAndConditionsBookingQuestion,
  requiredTermsAndConditionsBookingQuestion,
  termsAndConditionsBookingQuestionWithDefaultLabel,
  // Checkbox quesitons
  optionalCheckboxBookingQuestion,
  requiredCheckboxBookingQuestion,
  checkboxBookingQuestionWithSubquestions,
  // Dropdown questions
  optionalDropdownBookingQuestion,
  requiredDropdownBookingQuestion,
  legacyDropdownBookingQuestion,
  dropdownBookingQuestionWithSubquestions,
  // Misc
  serviceLimitedBookingQuestion,
];
